export default [
    {
        path: '/node',
        name: 'Node',
        component: () => import('@/views/node/index.vue'),
        meta: {
            auth: true, // 需要登录
            title: '节点',
            keepAlive: false,
            headerTheme: 'dark'
        }
    }
]
